module.exports = __webpack_public_path__ + "img/US_AreaDamage_ua.0e32af49.webp";